"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

function intersperse(arr, separator) {
  return arr.flatMap((item, idx) => idx < arr.length - 1 ? [item, separator] : [item]);
}

export { intersperse };
